import { axiosGet, axiosPost } from "./apiClient";

const BASE_URL = process.env.REACT_APP_BASE_URL + "/contact";

// const setTokenAllHeaders = async () => {
//   const token = localStorage.getItem("adminToken");
//   axios.defaults.headers.common["Authorization"] = token;
// };

const getAllContacts = async ({
  limit = 10,
  page = 0,
  status = null,
  sortModel = [],
  filterModel = {}
}) => {
  try {
    // Handle status conversion
    const sendStatus = status === 0 ? null : status;

    // Extract search text (from quick filter)
    const search = filterModel?.quickFilterValues?.[0] || null;

    // Extract additional filters
    const enquiryType = filterModel?.enquiryType || null;
    const contactType = filterModel?.contactType || null;
    const createdDate = filterModel?.createdDate || {};

    // Build query params
    const params = {
      limit,
      page,
      ...(sendStatus !== null ? { sendStatus } : {}),
      ...(search ? { search } : {}),
      ...(sortModel.length > 0
        ? {
          'sort[0][field]': sortModel[0].field,
          'sort[0][sort]': sortModel[0].sort,
        }
        : {}),

      // Filters
      ...(enquiryType ? { enquiryType } : {}),
      ...(contactType ? { contactType } : {}),
      ...(createdDate.start ? { 'createdDate[start]': createdDate.start } : {}),
      ...(createdDate.end ? { 'createdDate[end]': createdDate.end } : {}),
    };

    const response = await axiosGet(`${BASE_URL}/get`, { ...params });
    return response;
  } catch (error) {
    console.error("Error fetching contact message:", error);
    throw error;
  }
};


const updateContactStatus = async (params) => {
  try {
    // await setTokenAllHeaders();
    const dt = { ...params };
    const response = await axiosPost(`${BASE_URL}/status/`, dt);
    return response;
  } catch (error) {
    console.error(`Error updating contact message status:`, error);
    throw error;
  }
};




const contactApi = {
  getAllContacts,
  updateContactStatus
};

export default contactApi;
